import { initalAppConfig } from "../../system/config/appConfig";
import {SystemInterface} from "./interface";
import {SYSTEM_ACTIONS, SystemState} from "./types";

const initialState: SystemState = {
    themeDark: true,
    appConfig: initalAppConfig,
    initDone: false,
};

const systemReducer = (
    state: SystemState | undefined,
    action: SystemInterface
):SystemState  => {
    if (typeof state === 'undefined') {
        state = initialState;
    }

    switch (action.type) {
        case SYSTEM_ACTIONS.systemToggleDarkTheme:
            const themeStatus = state.themeDark;
            return {
                ...state,
                themeDark: !themeStatus
            };
        case SYSTEM_ACTIONS.systemSetAppConfig:
            return {
                ...state,
                appConfig: action.payload,
            };
        case SYSTEM_ACTIONS.systemSetInitDone:
            return {
                ...state,
                initDone: action.payload,
            }
        default:
            return state;
    }
}

export { systemReducer };
